import { render } from "./PeopleTags.vue?vue&type=template&id=144f91a4"
import script from "./PeopleTags.vue?vue&type=script&lang=js"
export * from "./PeopleTags.vue?vue&type=script&lang=js"
script.render = render

export default script